export default __webpack_public_path__ + "static/media/碳盤查3.0f0a453c.png";